import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import CreditsExplainerFeatureCard from './CreditsExplainerFeatureCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreditsExplainerFeatures = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "900",
    flexWrap: "wrap",
    children: [/*#__PURE__*/_jsx(View, {
      flex: 1,
      minInlineSize: "176px",
      children: /*#__PURE__*/_jsx(CreditsExplainerFeatureCard, {
        type: "simple"
      })
    }), /*#__PURE__*/_jsx(View, {
      flex: 1,
      minInlineSize: "176px",
      children: /*#__PURE__*/_jsx(CreditsExplainerFeatureCard, {
        type: "flexible"
      })
    })]
  });
};
export default CreditsExplainerFeatures;